import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button } from '@01_people/ui-library';
import ErrorPageSC from './error-page.styled';
import img403 from '../../assets/img/403.png';
import img404 from '../../assets/img/404.png';

const errorImages = {
  '403': img403,
  '404': img404
};

const ErrorPage = ({ status, history }) => {
  const { t } = useTranslation('pages');

  return (
    <ErrorPageSC>
      <div className="left">
        <span className="title">{t(`errors.${status}.title`)}</span>
        <span>{t(`errors.${status}.text`)}</span>
        <Button label={t('errors.button')} onClick={() => history.push('/')} />
      </div>
      <div className="right">
        <img src={errorImages[status]} alt={`error ${status}`} />
      </div>
    </ErrorPageSC>
  );
};

ErrorPage.propTypes = {
  status: PropTypes.oneOf(['403', '404']),
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.any.isRequired
};

ErrorPage.defaultProps = {
  status: '404'
};

export default ErrorPage;
